module.exports = __webpack_public_path__ + "img/icon-home.3d2564c0.svg";